import { Injectable } from "@angular/core";
import { Subject, BehaviorSubject, Observable } from "rxjs";
import { HttpClient } from '@angular/common/http';
import { StorageService } from "../storage/storage.service";
import * as settings from "../../lib/air-api-constant";
import { ISelectedFilters, IFilterValues, IFiltersCriteria } from "../../lib/types/selectedFilters";

@Injectable({
    providedIn: "root",
})

export class FilterService {

    public $filterIsSelected = new BehaviorSubject<boolean>(false);
    public filterVisibilitySubject = new Subject<boolean>();
    public companySelectionSubject = new BehaviorSubject<string>("");
    public filterSelectionDownloadOption = new BehaviorSubject<string>("");
    public $companyChanged = this.companySelectionSubject.asObservable();

    private filterSelection!: ISelectedFilters;
    private filterSelectionPromise = new BehaviorSubject<ISelectedFilters>(
        this.filterSelection
    );
    public $filterSelection = this.filterSelectionPromise.asObservable();

    public static assignedCompanies = [];

    public isKpiIndicatorsCalled: boolean = false;
    public staticKpiCardData: any = [];

    private keyRefPromise = new BehaviorSubject<any>({
        key: 'bdpRefno',
        label: 'Forwarder Ref No. ',
        value: '',
        shortLabel: 'Forwarder Ref No. ',
        keyIndex: 1
    });
    public $keyRef = this.keyRefPromise.asObservable();


    private ETAThresholdPromise = new BehaviorSubject<any>({ minLimit: -12, maxLimit: 12, etaConfigType: 1 });
    public $ETAThreshold = this.ETAThresholdPromise.asObservable();

    public bdpRepListPromise = new BehaviorSubject<any>([]);
    public $bdpRepListPromise = this.bdpRepListPromise.asObservable();

    public vesselNameListPromise = new BehaviorSubject<any>([]);
    public $vesselNameListPromise = this.vesselNameListPromise.asObservable();

    private metricFilterPromise = new BehaviorSubject<any>(null); // Created a behaviour subject 
    public $metricFilterPromise = this.metricFilterPromise.asObservable();


    constructor(
        private storageService: StorageService,
        private http: HttpClient
    ) {
        // Initialize filterSelection from storage
        this.filterSelection = this.storageService.getItem("filters");
        this.initializeKeyRef();
        // Check if any filter (excluding companies) is selected and update $filterIsSelected
        if (this.filterSelection) {
            const isFilterSelected = Object.keys(this.filterSelection).some(key => {
                if (key === 'companies') {
                    return false; // Exclude companies from the check
                }
                const value = this.filterSelection[key];
                if (Array.isArray(value)) {
                    return value.length > 0; // Check if the array is not empty
                }
                return value !== null && value !== undefined && value !== ''; // Check for non-empty values
            });
            this.setIsFilterSelectedStatus(isFilterSelected);
            this.setIsFilterSelectedStatus(false);
        } 
    }

    updateAssignedCompanies(companies: any) {
        FilterService.assignedCompanies = companies;
    }

    isStatusFilterSelected(selectedFilter: ISelectedFilters) {
        if (selectedFilter['statusType']?.length === 0)
            return false;
        else
            return true;
    }

    checkIfEmpty(filterSelection: any): boolean {
        let ifEmpty = false
        for (const filter in filterSelection) {
            if (filter == 'companies') { }
            else {
                if (filterSelection[filter].length > 0) {
                    ifEmpty = true
                }
            }
        }
        return ifEmpty
    }



    getETAThreshold(params: any = {}) {
        return new Promise((resolve: any, reject: any) => {
            this.http.get(
                settings.UserEndPoint.UserPortal.GET_ETA_THRESHOLD,
                params
            ).subscribe((response: any) => {
                resolve(response);
            }, reject);
        });
    }


    getETAThresholds(params: any = {}) {
        return this.http.get(
            settings.UserEndPoint.UserPortal.GET_ETA_THRESHOLD,
            params);
    }

    setETAThreshold(body: any = {}) {
        localStorage.setItem('persistent_eta_threshold', JSON.stringify(body));

        this.storageService.setItem('eta_threshold', body);
        this.ETAThresholdPromise.next(body);
        return this.http.post(settings.UserEndPoint.UserPortal.SET_ETA_THRESHOLD, body);
    }

    public changeCompanySelection(company: any) {
        this.companySelectionSubject.next(company);
    }

    public changeFilterVisibility(visibility: boolean) {
        this.filterVisibilitySubject.next(visibility);

    }

    public updateFilterSelection(filterSelection: any, calledFrom: string) {
        if (filterSelection !== 'noFilter') {
            this.filterSelection = filterSelection;
            this.filterSelectionPromise.next(filterSelection);
    
            // Don't update filter status if called from company change
            if (calledFrom === 'company' || calledFrom === 'GetCompanies') {
                return;
            }
    
            // Check if any filter (excluding companies) is selected
            const isFilterSelected = Object.keys(filterSelection).some(key => {
                // Skip company and empty checks
                if (key === 'companies') {
                    return false;
                }
    
                const value = filterSelection[key];
                
                if (Array.isArray(value)) {
                    return value.length > 0;
                }
                
                return value !== null && value !== undefined && value !== '';
            });
    
            this.setIsFilterSelectedStatus(isFilterSelected);
        } else {
            this.setIsFilterSelectedStatus(false);
        }
    
        // Update filter option state if not called from company change
        if (calledFrom !== 'company' && calledFrom !== 'GetCompanies') {
            this.filterSelectionDownloadOption.next(calledFrom);
        }
    }
    public isStatusTypeFilterSelectedOnly(selectedFilters: any, filter: any) {
        if (selectedFilters[filter] !== '') {
            // Check if other filters are empty
            for (let key in selectedFilters) {
                if (key !== 'statusType' && key !== 'companies') {
                    if ((Array.isArray(selectedFilters[key]) && selectedFilters[key].length > 0)
                        || (typeof selectedFilters[key] === 'number' && selectedFilters[key] !== 0)
                    ) {
                        return false; // Other filters are not empty
                    }
                }
                else if (key === 'statusType' && selectedFilters[key].length == 0) {
                    return false; // 'statusType' or 'companies' filter is empty
                }
            }
            return true; // statusType and companies are present, and other filters are empty
        }
        return false;
    }

    //To update the metric filter value so that it can be used anywhere needed.
    public updateMetricFilter(metricFilterSelection: any) {
        this.metricFilterPromise.next(metricFilterSelection);
    }

    private initializeKeyRef() {
        // Get saved keyRef from local storage
        const savedKeyRef = localStorage.getItem('keyReference');
        if (savedKeyRef) {
            this.updateAirKeyRef(savedKeyRef);
        }
    }
    public updateAirKeyRef(keyRef: string) {
         // Save keyRef to local storage
  ///  localStorage.setItem('keyReference', keyRef);
        const keyRefObj = {
            key: 'bdpRefno',
            label: 'Forwarder Ref No. ',
            value: '',
            shortLabel: 'Forwarder Ref No. ',
            keyIndex: keyRef
        };
        switch (keyRef) {
            case '2': {
                keyRefObj.key = 'awbNumber';
                keyRefObj.label = 'Master Awb No. ';
                keyRefObj.shortLabel = 'Master Awb No. ';
                break;
            }
            case '3': {
                keyRefObj.key = 'purchaseOrderNumber';
                keyRefObj.label = 'Purchase Order No. ';
                keyRefObj.shortLabel = 'Purchase Order No.  ';
                break;
            }
            case '4': {
                keyRefObj.key = 'shipperRefNumber';
                keyRefObj.label = 'Shipper Ref. No. ';
                keyRefObj.shortLabel = 'Shipper Ref. No. ';
                break;
            }
            case '5': {
                keyRefObj.key = 'houseBillNumber';
                keyRefObj.label = 'House Bill No. ';
                keyRefObj.shortLabel = 'House Bill No. ';
                break;
            }

            default: {
                keyRefObj.key = 'bdpRefno';
                keyRefObj.label = 'Forwarder Ref. No. ';
                keyRefObj.shortLabel = 'Forwarder Ref. No. ';
                break;
            }
        }
        this.keyRefPromise.next(keyRefObj);
    }

    public updateETAThreshold(ETAThreshold: string) {
        this.storageService.setItem('eta_threshold', ETAThreshold);
        this.ETAThresholdPromise.next(ETAThreshold);
    }

    public getIds(selectedFilters: any) {
        const filters: any = {
            companies: [],
            representatives: [],
            sbus: [],
            serviceCodes: [],
            carriers: [],
            flights: [],
            originRegion: [],
            originCountry: [],
            portOfDeparture: [],
            destinationRegion: [],
            destinationCountry: [],
            portOfArrival: [],
            placeOfReceipt: [],
            placeOfDelivery: [],
            shipmentType: 0,
            statusType: ""
        };
        if (selectedFilters) {
            for (let filter in filters) {
                if (filter == "shipmentPeriod") { }
                else {
                    if (Array.isArray(selectedFilters[filter])) {
                        if (selectedFilters[filter][0] == "" && selectedFilters[filter].length > 1) {
                            selectedFilters[filter].pop();
                        }
                        if (selectedFilters[filter].length) {
                            filters[filter] = selectedFilters[filter].map(
                                (filter: IFilterValues) => {
                                    return filter && filter.id ? filter.id : filter;
                                }
                            );
                        } else {
                            //  filters[filter]=[""];
                        }
                    } else {
                        switch (typeof selectedFilters[filter]) {
                            case "object": {
                                filters[filter] = [selectedFilters[filter].id];
                                break;
                            }
                            case "number": {
                                filters[filter] = selectedFilters[filter];
                                break;
                            }
                            case "string": {
                                if (filter === 'statusType') {
                                    // Handle statusType string case here
                                    filters[filter] = selectedFilters[filter];
                                } else {
                                    // For other string cases
                                    filters[filter] = [];
                                    filters[filter].push(selectedFilters[filter]);
                                }
                                break;
                            }
                            default: {
                                if (selectedFilters[filter] && selectedFilters[filter].length == 0) {
                                    filters[filter] = [""];
                                }
                            }
                        }
                    }
                }
            }
        }
        return filters;
    }
    getRegionCountryList(selectFilter: IFiltersCriteria): Observable<any> {
        return this.http.get(settings.UserEndPoint.AirFilters.ORIG_REGION_COUNTRY);
    }

    setIsFilterSelectedStatus(status: boolean) {
        this.$filterIsSelected.next(status);
    }

    getIsFilterSelectedStatus() {
        return this.$filterIsSelected.asObservable();
    }
}
